module.exports = __webpack_public_path__ + "static/media/supportedCropsImage.05f0f1e0.png";